export default __webpack_public_path__ + "static/media/person.ee8e2379.png";